module.exports = __webpack_public_path__ + "img/iamsmart.918d9617.jpg";